import Vue from 'vue';
import Router from 'vue-router';

export default () => {
  Vue.use(Router);

  const router = new Router({
    mode: 'history',
    base: '/ics/property/recommend/mobile',
    routes: [
      {
        path: '/',
        name: 'recommend',
        component: () => import('./recommend'),
      },
    ],
    scrollBehavior() {
      return { x: 0, y: 0 };
    },
  });

  router.beforeEach((to, from, next) => {
    Vue.$gmapDefaultResizeBus.$emit('resize');
    next();
  });

  return router;
};
